<template>
  <div>
    <form @submit.prevent="validateFields">
      <div
        v-for="(field, key) in fields"
        v-show="field.type"
        :key="`field-${key}`"
        class="dashboard-input-wrapper"
      >
        <input
          v-if="field.type"
          :type="field.type"
          :class="[
            'ine-input dashboard-input',
            errors.fields.includes(key) && 'ine-input--error',
          ]"
          @focus="clearErrors"
          :placeholder="field.placeholder"
          :autocomplete="field.autocomplete"
          v-model="field.value"
        />
        <Errors
          v-if="errors.fields.includes(key)"
          :errors="errors.messages[0]"
        />
      </div>
      <div class="profile__item-bottom-wrapper password__edit-wrapper">
        <PasswordVerifierWidget
          :password="fields['new password'].value"
          :isPasswordConfirmed="isPasswordConfirmed"
        />
        <div class="profile__item-btn-wrapper password__btn-wrapper">
          <button
            v-if="!isLoading"
            class="btn btn--primary profile__item-edit-btn"
            :disabled="isSaveDisabled"
          >
            Save
          </button>
          <button
            v-if="!isLoading"
            @click="$emit('toggle-update-section')"
            class="btn btn--tertiary profile__item-edit-btn"
            type="cancel"
          >
            Cancel
          </button>
          <ActionLoader v-else name="ball-clip-rotate" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Errors from '@/components/forms/elements/Errors.vue'
import PasswordVerifierWidget from '@/components/forms/PasswordVerifierWidget.vue'

export default {
  name: 'ProfileUpdatePasswordForm',
  components: {
    Errors,
    PasswordVerifierWidget,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    saveButtonDisabled: {
      type: Boolean,
      required: false,
    },
    isUpdatingSectionOpened: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isSaveDisabled: true,
      errors: clearFormErrors(),
      fields: {
        'current password': {
          type: 'password',
          rules: ['presence'],
          placeholder: 'Current Password',
          value: '',
          autocomplete: 'current-password',
        },
        'new password': {
          type: 'password',
          rules: ['presence', 'password'],
          placeholder: 'New Password',
          value: '',
          autocomplete: 'new-password',
        },
        'password confirmation': {
          type: 'password',
          rules: ['presence'],
          placeholder: 'Confirm New Password',
          value: '',
          autocomplete: 'new-password',
        },
      },
    }
  },
  watch: {
    fields: {
      handler: 'updateTypedPasswords',
      deep: true,
    },
  },
  computed: {
    isPasswordConfirmed() {
      return (
        (this.fields['new password'].value.length &&
          this.fields['new password'].value) ===
        this.fields['password confirmation'].value
      )
    },
  },
  methods: {
    validateFields() {
      if (!this.isPasswordConfirmed) {
        this.errors = {
          fields: ['new password', 'password confirmation'],
          messages: ['Passwords do not match'],
        }
        return
      }
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const payload = {
          password: fields['new password'].value,
          currentPassword: fields['current password'].value,
        }
        this.$emit('submit-form', payload)
      }
    },
    updateTypedPasswords() {
      if (this.isUpdatingSectionOpened) this.isSaveDisabled = false
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
  mounted() {
    this.isSaveDisabled = this.saveButtonDisabled
  },
}
</script>

<style lang="scss" scoped>
.password {
  &__edit-wrapper {
    margin-top: 20px;
    @include mobile {
      margin-top: 0;
    }
  }
  &__btn-wrapper {
    margin-top: 45px !important;
  }
}
</style>
